import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./header";

const API_ENDPOINT = API_URL + '/api';

export function addUserFavorite(data, params) {
    let obj = {
        ...getHeaderOptions(),
        Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return axios.post(`${API_ENDPOINT}/UserFavorite/AddUserFavorite`, data, { headers: obj, params: params })
}

export function removeUserFavorite(data, params) {
    let obj = {
        ...getHeaderOptions(),
        Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return axios.post(`${API_ENDPOINT}/UserFavorite/RemoveUserFavorite`, data, { headers: obj, params: params })
}

export const getUserFavourites = (params) => {
    let obj = {
        ...getHeaderOptions(),
        Authorization: "Bearer " + localStorage.getItem("token"),
    };
    return axios.get(`${API_ENDPOINT}/UserFavorite/GetUserFavorites`, { headers: obj, params: params })
}